import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

import atualizalocal from './modules/atualizalocal';
import auth from './modules/auth';
import cache from './modules/cache';
// import debug from './modules/debug';
import empresa from './modules/empresa';
import modulos from './modules/modulos';
import permissao from './modules/permissao';
// import users from './modules/users';
import grupo from './modules/grupo';
import produto from './modules/produto';
import cliente from './modules/cliente';
import scroll from './modules/infinite-scroll';
import coleta from './modules/coleta';
import filter from './modules/filter';
import vendedor from './modules/vendedor';

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {
    async $_setup({ dispatch }) {
      await dispatch('auth/$_setup');
    },
  },

  modules: {
    atualizalocal,
    auth,
    // users,
    empresa,
    permissao,
    modulos,
    cache,
    grupo,
    produto,
    cliente,
    scroll,
    coleta,
    filter,
    vendedor
  }, 
  plugins: [createPersistedState({
    paths: [''],
    storage: window.sessionStorage,
  })],
});
